
import { Component, Prop } from '@modules/vue-property-decorator';
import CircleIcon from '@shared/components/container/circleIcon.vue';
import Container from '@shared/components/container/container.vue';
import Navigation from '@shared/components/navigation/navigation.vue';
import { ModifyMode } from '@shared/core/constants';
import { Format } from '@shared/core/helpers/formatHelper';
import { SaleItem } from '@shared/core/interfaces/saleItem';
import { Settings } from '@shared/core/services/configService';
import { CrudService } from '@shared/core/services/crudService';
import { ShopService } from '@shared/core/services/shopService';
import Vue from 'vue';
import CheckoutFooter from './checkoutFooter.vue';

@Component({
  components: {
    Container,
    CircleIcon,
    Navigation,
    CheckoutFooter,
  },
})
export default class CheckoutSummary extends Vue {
  @Prop() cid!: any;
  private readonly shopService: ShopService;
  private readonly crudService: CrudService;
  private promoCode: string = "";
  private errorPromo: string = "";
  private okPromo: string = "";
  private discount: number = 0;
  private netDiscount: number = 0;
  private discountedTaxes: number = 0;

  constructor() {
    super();
    this.shopService = new ShopService();
    this.crudService = new CrudService();
  }
  
  private get pricesWithTaxes() {
    return this.$store.state.settings.PriceWithTaxes;
  }

  private get sItems() {
    return this.$store.state.cart.sItems;
  }

  private get sales() {
    return this.$store.state.cart.sales;
  }

  private get discountInfo() {
    return {
      promoCode: this.promoCode,
      discount: this.discount,
      netDiscount: this.netDiscount,
      discountedTaxes: this.discountedTaxes,
    };
  }

  private getImagePath(img?: string | null) {
    if (!img) {
      return this.$store.state.settings.Uploads + "/" + this.$store.state.settings.Mainlogo;
    }
    return this.$store.state.settings.Uploads + "/" + img;
  }

  private getPrice(grossPrice: any, netPrice: any) {
    return this.formatPrice(this.pricesWithTaxes ? grossPrice : netPrice);
  }

  private formatPrice(price: any) {
    return Format.formatCurrency(price);
  }

  private async removeSaleItemFromCart(saleItem: SaleItem) {
    await this.shopService.removeSaleItemFromCart(saleItem);
  }

  private removeSaleFromCart(saleId: number) {
    this.shopService.removeSaleFromCart(saleId);
  }

  private incrementUnits(sItem: SaleItem) {
    this.shopService.modifyUnits(ModifyMode.Increment, sItem, 1);
  }

  private decrementUnits(sItem: SaleItem) {
    this.shopService.modifyUnits(ModifyMode.Decrement, sItem, 1);
  }

  private modifyUnits(sItem: SaleItem) {
    const units = Number(sItem.units);
    if (isNaN(units)) {
      return;
    }
    this.shopService.modifyUnits(ModifyMode.Exact, sItem, units);
  }

  async validatePromo() {
    this.errorPromo = "";
    this.okPromo = "";

    if (
      this.promoCode === "" ||
      this.promoCode === undefined ||
      this.promoCode === null
    ) {
      return;
    }

    // if promos saleitems must be 1 unit each

    const url = `${Settings.HostName}/api/promos/validate`;
    const data = await this.crudService.httpPost(url, {
      code: this.promoCode,
      customerId: this.cid,
      saleItems: this.getSaleItems(),
      saleIds: this.$store.state.cart.sales.map(function (v) {
        return v.id;
      }),
    });

    if (
      data == null ||
      data === undefined ||
      (data.ok === false && data.errorMsg === null)
    ) {
      this.errorPromo = this.$t("Sorry, the code is not valid").toString();
      return;
    }

    if (data.ok === false) {
      this.errorPromo = data.errorMsg;
      return;
    }
    this.okPromo = this.$t("Discount Applied").toString();
    this.discount = data.data.discount;
    this.netDiscount = data.data.netDiscount;
    this.discountedTaxes += data.data.discountedTaxes;
    this.$emit('promoApplied', {
      promoCode: this.promoCode,
      discount: this.discount,
      netDiscount: this.netDiscount,
      discountedTaxes: this.discountedTaxes,
    });
  }

  private getSaleItems() {
    let saleItems = this.$store.state.cart.sItems.filter((y) => y.units > 0);
    if (this.promoCode === "") {
      return saleItems;
    }

    // one saleitem per line to calculate promos
    let saleItemsDto: any[] = [];
    for (const sItem of saleItems) {
      for (let j = 0; j < sItem.units; j++) {
        let unitOneSaleItem = Object.assign({}, sItem);
        unitOneSaleItem.units = 1;
        unitOneSaleItem.customerId = this.cid;
        unitOneSaleItem.buyerCustomerId = this.cid;
        saleItemsDto.push(unitOneSaleItem);
      }
    }
    return saleItemsDto;
  }
}
